import React from 'react';
import PropTypes from 'prop-types';

import LoginButton from './LoginButton';
import RegisterButton from './RegisterButton';

export default function HeaderButtons({ location, isLoggedIn }) {
  if (isLoggedIn) {
    return null;
  }

  return (
    <div className="hd-authButtons">
      <div className="btn-wrapper">
        <LoginButton className="btn-secondary" currentLocation={location} />
        <RegisterButton className="btn-primary" currentLocation={location} />
      </div>
    </div>
  );
}

HeaderButtons.propTypes = {
  location: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};
